import {
  DefaultSection,
  MainSection,
  Paragraph,
  ListSection,
  SectionSubTitle,
} from "./components";
import { useTranslation } from "react-i18next";

import "./privacyAndTerms.scss";

export const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="container-main-privacy-terms">
      <div className="section-container">
        <MainSection
          firstTilte={t("privacy_policy.main_section.first_tilte")}
          secondTilte={t("privacy_policy.main_section.second_title")}
          text={t("privacy_policy.main_section.text")}
          type="privacyPolicy"
        />

        <DefaultSection title={t("privacy_policy.introduction_section.title")}>
          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_1")}
          />
          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_3")}
          />
          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_3")}
          />
          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_4")}
          />
          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_5")}
          />
          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_6")}
          />
          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_7")}
          />

          <ListSection>
            <li>{t("privacy_policy.introduction_section.list.item_1")}</li>
            <li>{t("privacy_policy.introduction_section.list.item_2")}</li>
            <li>{t("privacy_policy.introduction_section.list.item_3")}</li>
          </ListSection>

          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_8")}
          />
          <Paragraph
            text={t("privacy_policy.introduction_section.paragraph_9")}
          />
        </DefaultSection>

        <DefaultSection title={t("privacy_policy.colected_data_section.title")}>
          <div>
            <SectionSubTitle
              text={t(
                "privacy_policy.colected_data_section.sub_section_1.sub_title"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_1.paragraph_1"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_1.paragraph_2"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_1.paragraph_3"
              )}
            />
          </div>

          <div>
            <SectionSubTitle
              text={t(
                "privacy_policy.colected_data_section.sub_section_2.sub_title"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_2.paragraph_1"
              )}
            />
          </div>

          <div>
            <SectionSubTitle
              text={t(
                "privacy_policy.colected_data_section.sub_section_3.sub_title"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_3.paragraph_1"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_3.paragraph_2"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_3.paragraph_3"
              )}
            />
          </div>

          <div>
            <SectionSubTitle
              text={t(
                "privacy_policy.colected_data_section.sub_section_4.sub_title"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_4.paragraph_1"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_4.paragraph_2"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_4.paragraph_3"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_4.paragraph_4"
              )}
            />
          </div>

          <div>
            <SectionSubTitle
              text={t(
                "privacy_policy.colected_data_section.sub_section_5.sub_title"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_5.paragraph_1"
              )}
            />
            <Paragraph
              text={t(
                "privacy_policy.colected_data_section.sub_section_5.paragraph_2"
              )}
            />
          </div>
        </DefaultSection>

        <DefaultSection title={t("privacy_policy.data_use_section.title")}>
          <Paragraph text={t("privacy_policy.data_use_section.paragraph_1")} />
          <Paragraph text={t("privacy_policy.data_use_section.paragraph_2")} />
          <Paragraph text={t("privacy_policy.data_use_section.paragraph_3")} />
        </DefaultSection>

        <DefaultSection title={t("privacy_policy.gdpr_section.title")}>
          <Paragraph text={t("privacy_policy.gdpr_section.paragraph_1")} />

          <ListSection>
            <li>{t("privacy_policy.gdpr_section.list.item_1")}</li>
            <li>{t("privacy_policy.gdpr_section.list.item_2")}</li>
            <li>{t("privacy_policy.gdpr_section.list.item_3")}</li>
            <li>{t("privacy_policy.gdpr_section.list.item_4")}</li>
            <li>{t("privacy_policy.gdpr_section.list.item_5")}</li>
            <li>{t("privacy_policy.gdpr_section.list.item_6")}</li>
            <li>{t("privacy_policy.gdpr_section.list.item_7")}</li>
            <li>{t("privacy_policy.gdpr_section.list.item_8")}</li>
          </ListSection>

          <Paragraph text={t("privacy_policy.gdpr_section.paragraph_2")} />
          <Paragraph text={t("privacy_policy.gdpr_section.paragraph_3")} />
          <Paragraph text={t("privacy_policy.gdpr_section.paragraph_4")} />
          <Paragraph text={t("privacy_policy.gdpr_section.paragraph_5")} />
        </DefaultSection>

        <DefaultSection
          title={t("privacy_policy.protector_structure_section.title")}
        >
          <Paragraph
            text={t("privacy_policy.protector_structure_section.paragraph_1")}
          />
        </DefaultSection>

        <DefaultSection title={t("privacy_policy.retention_section.title")}>
          <Paragraph text={t("privacy_policy.retention_section.paragraph_1")} />
          <Paragraph text={t("privacy_policy.retention_section.paragraph_2")} />
          <Paragraph text={t("privacy_policy.retention_section.paragraph_3")} />
        </DefaultSection>

        <DefaultSection title={t("privacy_policy.contact_section.title")}>
          <Paragraph text={t("privacy_policy.contact_section.paragraph_1")} />
        </DefaultSection>

        <DefaultSection title={t("privacy_policy.resolution_section.title")}>
          <Paragraph
            text={t("privacy_policy.resolution_section.paragraph_1")}
          />
          <Paragraph
            text={t("privacy_policy.resolution_section.paragraph_2")}
          />
          <Paragraph
            text={t("privacy_policy.resolution_section.paragraph_3")}
          />
          <Paragraph
            text={t("privacy_policy.resolution_section.paragraph_4")}
          />
        </DefaultSection>

        <DefaultSection title={t("privacy_policy.alterations_section.title")}>
          <Paragraph
            text={t("privacy_policy.alterations_section.paragraph_1")}
          />
          <Paragraph
            text={t("privacy_policy.alterations_section.paragraph_2")}
          />
          <Paragraph
            text={t("privacy_policy.alterations_section.paragraph_3")}
          />
          <Paragraph
            text={t("privacy_policy.alterations_section.paragraph_4")}
          />
        </DefaultSection>

        <DefaultSection title={t("privacy_policy.original_section.title")}>
          <Paragraph text={t("privacy_policy.original_section.paragraph_1")} />
        </DefaultSection>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
